import React from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    
} from "react-router-dom";



// ================= CUSTOMER PAGES =================

import Home from "./pages/Home";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import GalleryCategory from "./pages/GalleryCategory";

import Feedback from "./pages/FeedbackPage";
import Contact from "./pages/ContactPage";
import PackageDetails from "./pages/PackageDetails";

// ================= ADMIN =================

import Login from "./admin/LoginPages/LoginPage";


import UploadPhoto from "./admin/Upload/UploadPhoto";
import UploadVideo from "./admin/Upload/UploadVideo";

import AdminAbout from "./admin/CustomerWebSite/AdminAbout";


import AdminFeedbackPage from "./admin/CustomerWebSite/AdminFeedbackPage";
import AdminFeedback from "./admin/Feedback/FeedbackList";

import AdminContactPage from "./admin/CustomerWebSite/AdminContactPage";
import AdminContact from "./admin/Contact/ContactList";


import AdminPackages from "./admin/CustomerWebSite/AdminPackages";



import Register from "./admin/LoginPages/Register";
import ForgotPassword from "./admin/LoginPages/ForgotPassword";
import ChangePassword from "./admin/LoginPages/ChangePassword";

// ================= PACKAGE =================

import AddPackage from "./admin/Package/AddPackage";
import EditPackage from "./admin/Package/EditPackage";
import ManagePackages from "./admin/Package/ManagePackages";

// ================= GALLERY =================

import AddGalleryCategory from "./admin/Gallery/AddGalleryCategory";
import EditGalleryCategory from "./admin/Gallery/EditGalleryCategory";
import AdminGalleryCategories from "./admin/Gallery/AdminGalleryCategories";

import ManagePhotos from "./admin/Upload/ManagePhotos";
import ManageVideos from "./admin/Upload/ManageVideos";

import AdminLayout from "./admin/AdminLayout";
import ManageGallery from "./admin/Gallery/ManageGallery";
import AdminHomeMedia from "./admin/HomePage/AdminHomeMedia";
import AdminHome from "./admin/CustomerWebSite/AdminHome";
import AdminGallery from "./admin/CustomerWebSite/AdminGallery";

import Packages from "./pages/Packages"; 
import ScrollToTop from "./pages/ScrollToTop";



//import "./assets/css/responsive.css";
//import "./assets/css/admin/adminResponsive.css";

function AppContent() {  
  

    return (

        <>


            <Routes>

                {/* Default */}

                <Route
                    path="/"
                    element={<Navigate to="/home" replace />}
                />

                {/* Customer */}

                <Route path="/home" element={<Home />} />

                <Route path="/about" element={<About />} />

                <Route path="/gallery" element={<Gallery />} />

                <Route
                    path="/gallery/:category"
                    element={<GalleryCategory />}
                />

                <Route path="/packages" element={<Packages />} />

                <Route path="/feedback" element={<Feedback />} />

                <Route path="/contact" element={<Contact />} />

                <Route
                    path="/package/:id"
                    element={<PackageDetails />}
                />

            

              

                {/* Dashboard */}

                <Route
                    path="/admin/layout"
                    element={<AdminLayout/>}
                />

                {/* Upload */}

                <Route
                    path="/admin/upload"
                    element={<UploadPhoto />}
                />

                <Route
                    path="/admin/upload-video"
                    element={<UploadVideo />}
                />

                {/* Admin Pages */}
                    <Route
                    path="/admin/home"
                    element={<AdminHome />}
                />
                <Route
                    path="/admin/about"
                    element={<AdminAbout />}
                />

                

                <Route
                    path="/admin/feedbackPage"
                    element={<AdminFeedbackPage />}
                />

                <Route
                    path="/admin/feedback"
                    element={<AdminFeedback />}
                />

                <Route
                    path="/admin/contactpage"
                    element={<AdminContactPage />}
                />

                <Route
                    path="/admin/contact"
                    element={<AdminContact />}
                />
                  <Route
    path="/admin/gallery-categories"
    element={<AdminGalleryCategories />}
/>             

                <Route
                    path="/admin/packages"
                    element={<AdminPackages />}
                />

                {/* Home Image */}

                <Route
                    path="/admin/homemedia"
                    element={<AdminHomeMedia />}
                />

                {/* Packages */}

                <Route
                    path="/admin/add-package"
                    element={<AddPackage />}
                />

                <Route
                    path="/admin/edit-package/:id"
                    element={<EditPackage />}
                />

                <Route
                    path="/admin/manage-packages"
                    element={<ManagePackages />}
                />

                {/* Gallery Categories */}

                <Route
                    path="/admin/gallery-categories"
                    element={<AdminGalleryCategories />}
                />

                <Route
                    path="/admin/add-gallery-category"
                    element={<AddGalleryCategory />}
                />
                 <Route
    path="/admin/edit-gallery-category/:id"
    element={<EditGalleryCategory />}
/>
                {/* Gallery Management */}

                <Route
                    path="/admin/manage-gallery/photos/:category"
                    element={<ManagePhotos />}
                />

                <Route
                    path="/admin/manage-gallery/videos/:category"
                    element={<ManageVideos />}
                />

               <Route path="/admin/manage-gallery"   element={<ManageGallery />}/>
                 <Route
    path="/admin/manage-gallery/:category"
    element={<ManageGallery />}
/>
         <Route path="/admin/gallery" element={<AdminGallery />} />

             <Route path="/admin/login" element={<Login />} />

<Route path="/admin/register" element={<Register />} />

<Route path="/admin/forgot-password" element={<ForgotPassword />} />

<Route path="/admin/change-password" element={<ChangePassword />} />
            </Routes>

        </>

    );

}

function App() {

    return (

        <BrowserRouter>
               
    <ScrollToTop />
            <AppContent />
           
        </BrowserRouter>

    );

}

export default App;